import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var FORM_SELECTOR = 'js-cross-sell-add-to-cart-form';
var REF_SELECTOR = 'input[name="reflm"]';
var QUANTITY_SELECTOR = 'input[name="quantity"]';
var OFFER_SELECTOR = 'input[name="offerId"]';
var CONTEXT_SELECTOR = 'input[name="contextCode"]';
var AddToCartForTopProducts = /*#__PURE__*/function () {
  function AddToCartForTopProducts() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var cartUpdateEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, AddToCartForTopProducts);
    try {
      if (element === null) throw 'element params is mandatory';
      if (cartUpdateEvent === null) throw 'cartUpdateEvent params is mandatory';
      this.cartUpdateEvent = cartUpdateEvent;
      this.forms = element.querySelectorAll(".".concat(FORM_SELECTOR));
    } catch (e) {
      throw "error : ".concat(e);
    }
  }
  return _createClass(AddToCartForTopProducts, [{
    key: "init",
    value: function init() {
      if (this.forms) addSubmitEventsForms.call(this);
    }
  }]);
}();
function addSubmitEventsForms() {
  var _this = this;
  this.forms.forEach(function (form) {
    form.addEventListener('submit', dispatchEvent.bind(_this, form));
  });
}
function dispatchEvent(form, event) {
  event.preventDefault();
  var reflm = form.querySelector(REF_SELECTOR).value;
  var quantity = form.querySelector(QUANTITY_SELECTOR).value;
  var offerId = form.querySelector(OFFER_SELECTOR) ? form.querySelector(OFFER_SELECTOR).value : null;
  var contextCode = form.querySelector(CONTEXT_SELECTOR) ? form.querySelector(CONTEXT_SELECTOR).value : null;
  this.cartUpdateEvent({
    listProducts: [{
      reflm: reflm,
      quantity: quantity,
      offerId: offerId,
      contextCode: contextCode,
      reflmAvailability: null
    }]
  });
}
export default AddToCartForTopProducts;